import { render } from "./ItemClassificationForm.vue?vue&type=template&id=5e46ce18"
import script from "./ItemClassificationForm.vue?vue&type=script&lang=js"
export * from "./ItemClassificationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__